export default {
  ess_language: {
    language: {
      en_US: 'English',
      es_ES: 'Español'
    }
  }
}
